<div id="yalla-bg">
</div>

  <div class="yalla-container">
    <div class="yalla-logo">
      <img src="assets/img/yalla-arabian-cup/yalla-logo.png" width="150" alt="">
    </div>

    <div class="go_button yalla-awc sm square" (click)="multidialog('shareYallaAWC')" >
      <div class="snow share"></div>
      <i class="icon-share" >Share</i>
    </div>

    <div class="corner-tr">
      <img src="assets/img/yalla-arabian-cup/yalla-corner.svg" alt="">
    </div>
    <div class="corner-tl">
      <img src="assets/img/yalla-arabian-cup/yalla-corner.svg" alt="">
    </div>

    <div class="corner-br">
      <img src="assets/img/yalla-arabian-cup/yalla-corner.svg" alt="">
    </div>

    <div class="corner-bl">
      <img src="assets/img/yalla-arabian-cup/yalla-corner.svg" alt="">
    </div>


    <div class="flags-container">

      <div class="flags-frame-container">
        <div class="corner-tr">
          <img src="assets/img/yalla-arabian-cup/flag-frame.svg" alt="">
        </div>
        <div class="corner-tl">
          <img src="assets/img/yalla-arabian-cup/flag-frame.svg" alt="">
        </div>

        <div class="corner-br">
          <img src="assets/img/yalla-arabian-cup/flag-frame.svg" alt="">
        </div>

        <div class="corner-bl">
          <img src="assets/img/yalla-arabian-cup/flag-frame.svg" alt="">
        </div>
      </div>

      <div class="countries">
        <img src="assets/img/yalla-arabian-cup/flags-line.png" class="img-responsive" alt="">
      </div>
      <div class="yalla-cup-logo">
        <img src="assets/img/yalla-arabian-cup/arabian_world_cup.png" class="img-responsive" alt="">
      </div>
    </div>

    <div class="title">
      <h1>The Arabian <br> World Cup</h1>
      <p>أكبر بطولة فورت نايت تريو للمنتخبات</p>
<!--      <h2>25th of September</h2>-->
    </div>

    <div class="partners">
      <p>Partners</p>
      <div class="partners-images">
        <img src="assets/img/yalla-arabian-cup/logitech-logo.png" class="img-responsive" width="120" alt="Logitech Logo">
        <img src="assets/img/yalla-arabian-cup/gbarena-type.svg" class="img-responsive" width="60" alt="GBarena Logo">
        <img src="assets/img/yalla-arabian-cup/saqr-logo.png" class="img-responsive" width="90" alt="Saqr eSports Logo">
      </div>
    </div>

    <app-yalla-awc-tournaments></app-yalla-awc-tournaments>

</div>


